export default function () {
  return {
    loading: false,
    paymentData: null,
    paymentCraftgate: null,
    paymentHtml: '',
    status: false,
  }
}
